
<template>
  <span>

    <el-button type="primary" @click="showprint = true" size="small" icon="el-icon-printer"
      style="display: inline-block; margin-left: 10px;background-color: #fff;color: #E6A23C;border-color: #E6A23C;">{{
        btnTag }}</el-button>

    <printViewFun :showprint="showprint" :changeList="changeList" @close="showprint = false" :modules="modules"
      :isList="isList" v-if="showprint" :printFun="printFun"></printViewFun>

  </span>
</template>
  
<script>
// import { borderBottomLeftRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';

export default {
  props: {
    isList: {
      type: Boolean,
      required: false,
      default: false
    },
    btnTag: {
      type: String,
      required: false,
      default: '打印'
    },
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    // table多选数据
    changeList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showprint: false
    };
  }
};
</script>
  
<style scoped>
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
